<template>
  <b-container fluid>
    <div class="card-main">
      <b-row class="">
        <b-col md="7" sm="12" class="">
          <b-row>
            <b-col
              md="2"
              class="
                d-none d-md-block d-flex
                align-self-center
                justify-content-center
              "
            >
              <b-avatar
                button
                :src="user.foto.nome"
                size="75%"
                @click="pickImage()"
              ></b-avatar>
              <div hidden="true" class="mt-3">
                <b-form-group label="Selecione uma foto" label-for="fileInput">
                  <b-form-file
                    id="fileInput"
                    type="file"
                    accept="image/*"
                    name="fileInput"
                    placeholder="Selecione uma foto"
                    ref="pickAvatar"
                    @change="upload"
                  ></b-form-file>
                </b-form-group>
              </div>
            </b-col>

            <b-col md="6" sm="12">
              <b-form-group label="Nome" label-for="input-1">
                <b-form-input
                  class=""
                  v-model="user.nome"
                  :state="
                    validation.hasError('user.nome')
                      ? false
                      : user.nome.length >= 1
                      ? true
                      : null
                  "
                  autofocus
                  id="input-1"
                ></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  Digite seu Nome completo.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4" sm="12">
              <b-form-group label="Sexo" label-for="input-2">
                <multiselect
                  id="input-2"
                  v-model="user.genero"
                  :options="tipoSexo"
                  :multiple="false"
                  :preserve-search="true"
                  :searchable="false"
                  :allow-empty="true"
                  :select-label="''"
                  :deselectLabel="''"
                  :selectedLabel="''"
                  placeholder="Selecione uma opção"
                  track-by="nome"
                  label="nome"
                  
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.nome }}</strong>
                  </template>
                </multiselect>
                <div class="message">
                  {{ validation.firstError("user.genero") }}
                </div>
              </b-form-group>
            </b-col>

            <b-col md="8" sm="12">
              <b-form-group label="E-mail" label-for="input-3">
                <b-form-input
                  id="input-3"
                  lazy-formatter
                  :state="
                    validation.hasError('user.email')
                      ? false
                      : user.email != ''
                      ? true
                      : null
                  "
                  type="email"
                  autocomplete="off"
                  v-model="user.email"
                ></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  Digite um endereço de e-mail válido.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col md="4" sm="12">
              <b-form-group label="Pretensão Salarial" label-for="input-4">
                <b-form-input
                  class="form-control"
                  type="number"
                  :state="
                    validation.hasError('user.pretensao_salarial')
                      ? false
                      : user.pretensao_salarial >= 1
                      ? true
                      : null
                  "
                  id="input-4"
                  v-model="user.pretensao_salarial"
                >
                </b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  O Valor acima deve ser maior que um.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5" sm="12">
              <b-form-group label="Nascimento" label-for="input-5">
                <b-input-group>
                  <b-form-input
                    class="form-control"
                    id="input-5"
                    v-mask="'##/##/####'"
                    autocomplete="off"
                    :state="
                      validation.hasError('user.data_nascimento')
                        ? false
                        : user.data_nascimento.length >= 10
                        ? true
                        : null
                    "
                    v-model="user.data_nascimento"
                    @change="formatPicker"
                  >
                  </b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="dateFormat"
                      button-only
                      right
                      aria-controls="input-4"
                      @context="dateFormatter($event)"
                    ></b-form-datepicker>
                  </b-input-group-append>
                  <b-form-invalid-feedback id="input-live-feedback">
                    {{ validation.firstError("user.data_nascimento") }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="5" sm="12">
              <b-form-group label="Estado Cívil" label-for="input-6">
                <multiselect
                  id="input-6"
                  v-model="user.estado_civil"
                  :options="tipoCivil"
                  :multiple="false"
                  :preserve-search="true"
                  placeholder="Selecione uma opção"
                  track-by="nome"
                  label="nome"
                  :allow-empty="true"
                  :select-label="''"
                  :deselectLabel="''"
                  :selectedLabel="''"
                  :searchable="false"
                  
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.nome }}</strong>
                  </template>
                </multiselect>
                <div class="message">
                  {{ validation.firstError("user.estado_civil") }}
                </div>
              </b-form-group>
            </b-col>

            <b-col md="2" sm="12">
              <b-form-group label="Nº Filhos" label-for="input-7">
                <b-form-input
                  type="number"
                  min="0"
                  id="input-7"
                  v-model="user.numero_filhos"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="5" sm="12" class="endereco_wrapper">
              <b-form-group label="CEP" label-for="input-8">
                <b-form-input
                  id="input-8"
                  v-model="user.cep"
                  v-mask="'#####-###'"
                  lazy-formatter                  
                  v-on:keyup="findcep()"
                ></b-form-input>
                <small>
                  <a
                    href="http://www.buscacep.correios.com.br/sistemas/buscacep/BuscaCepEndereco.cfm"
                    target="_blank"
                  >
                    Não sabe o seu cep? clique aqui
                  </a>
                </small>
                <b-form-invalid-feedback id="input-live-feedback">
                  Digite um CEP válido.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col md="7" sm="12" class="endereco_wrapper">
              <b-form-group
                label="Logradouro(Rua/Av/Praça/...)"
                label-for="input-24"
              >
                <b-form-input
                  id="input-24"
                  
                  v-model="user.logradouro"
                  
                  
                  
                ></b-form-input>
                <div class="message">
                  {{ validation.firstError("user.logradouro") }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col lg="2" md="2" sm="12" class="endereco_wrapper">
              <b-form-group label="Número" label-for="input-9">
                <b-form-input
                  id="input-9"
                  v-model="user.numero"
                  :state="
                    validation.hasError('user.numero')
                      ? false
                      : user.numero
                      ? true
                      : null
                  "
                  
                ></b-form-input>
                <div class="message">
                  {{ validation.firstError("user.numero") }}
                </div>
              </b-form-group>
            </b-col>

            <b-col md="2" sm="12">
              <b-form-group label="UF" label-for="input-10">
                <b-form-input
                  id="input-10"
                  disabled
                  v-model="user.estado_id.nome"
                ></b-form-input>
                <div class="message">
                  {{ validation.firstError("user.estado_id.nome") }}
                </div>
              </b-form-group>
            </b-col>

            <b-col md="8" sm="12">
              <b-form-group label="Cidade" label-for="input-13">
                <b-form-input
                  id="input-13"
                  disabled
                  v-model="user.cidade_id.nome"
                ></b-form-input>
                <div class="message">
                  {{ validation.firstError("user.cidade_id.nome") }}
                </div>
              </b-form-group>
            </b-col>     
          </b-row>

          <b-row>
            <b-col md="6" sm="12">
              <b-form-group label="Bairro" label-for="input-12">
                <b-form-input
                  id="input-12"
                  v-model="user.bairro"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="6" sm="12" class="endereco_wrapper">
              <b-form-group label="Complemento" label-for="input-11">
                <b-form-input
                  id="input-11"
                  v-model="user.complemento"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="5" sm="12" class="left-column-wrapper">
          <b-row>
            <b-col md="2" sm="12">
              <b-form-group label="CNH" label-for="input-14">
                <b-form-checkbox
                  id="input-14"
                  v-model="user.cnh"
                  name="chkCNH"
                  value="1"
                  unchecked-value="0"
                  stacked
                />
              </b-form-group>
            </b-col>

            <b-col md="10" sm="12">
              <b-form-group
                v-if="user.cnh == 1"
                label="Tipo:"
                label-for="input-15"
              >
                <multiselect
                  id="input-15"
                  v-model="user.cnh_categoria"
                  :options="tipoCnh"
                  :multiple="false"
                  :preserve-search="true"
                  placeholder="Selecione uma opção"
                  track-by="nome"
                  label="nome"
                  :allow-empty="false"
                  :select-label="''"
                  :deselectLabel="''"
                  :selectedLabel="''"
                  
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.nome }}</strong>
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="2" sm="12">
              <b-form-group label="PCD" label-for="input-16">
                <b-form-checkbox
                  id="input-16"
                  v-model="user.pcd"
                  name="chkPCD"
                  value="1"
                  unchecked-value="0"
                  stacked
                />
              </b-form-group>
            </b-col>

            <b-col md="10" sm="11">
              <b-form-group
                v-if="user.pcd == 1"
                label="Tipo PCD"
                label-for="input-17"
              >
                <multiselect
                  id="input-17"
                  v-model="user.pcd_descricao"
                  :options="tipoDeficiencia"
                  :multiple="false"
                  :preserve-search="true"
                  placeholder="Selecione uma opção"
                  track-by="nome"
                  label="nome"
                  :allow-empty="false"
                  :select-label="''"
                  :deselectLabel="''"
                  :selectedLabel="''"
                  
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.nome }}</strong>
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="12" md="12" sm="12">
              <b-form-group
                label="Selecione os cargos pretendidos"
                label-for="input-18"
              >
                <multiselect
                  id="input-18"
                  v-model="user.cargos"
                  :options="cargosPretendidos"
                  :max="5"
                  label="nome"
                  track-by="id"
                  placeholder="Digite para pesquisar...."
                  open-direction="bottom"
                  :multiple="true"
                  :searchable="true"
                  :internal-search="false"
                  :clear-on-select="true"
                  :close-on-select="true"
                  :select-label="'clique para selecionar'"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  @search-change="buscarCargos"
                >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.nome }}</span>
                      <span class="custom__remove" @click="remove(option)">
                        ❌
                      </span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="user.cargos.length"
                      @mousedown.prevent.stop="clearAll(props.search)"
                    ></div>
                  </template>
                  <span slot="noResult">
                    Oops! Não encontramos cargos de acordo com a sua pesquisa.
                  </span>
                  <span slot="maxElements">
                    Numero máximo de 5 cargos, para adcionar um novo remova
                    primeiro um dos selecionados
                  </span>
                  <span slot="noOptions">
                    Lista de cargos pesquisados vazia
                  </span>
                </multiselect>
                <div class="message">
                  {{ validation.firstError("user.cargos") }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4" sm="12">
              <b-form-group label="Telefone" label-for="input-19">
                <b-form-input
                  id="input-19"
                  v-model="user.telefone"
                  v-mask="'## ####-####'"
                  
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4" sm="12">
              <b-form-group label="Celular" label-for="input-20">
                <b-form-input
                  id="input-20"
                  v-model="user.celular"
                  v-mask="'## # ####-####'"
                >
                </b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4" sm="12">
              <b-form-group label="Whatsapp" label-for="input-21">
                <b-form-checkbox
                  id="input-21"
                  v-model="user.whatsapp"
                  name="input-21"
                  value="Sim"
                  unchecked-value="Nao"
                  class="d-flex justify-content-start align-items-start"
                >
                  {{ user.whatsapp == "Sim" ? "Sim" : "Não" }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="6" md="6" sm="12">
              <b-form-group label="Skype" label-for="input-22">
                <b-form-input id="input-22" v-model="user.skype"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="12">
              <b-form-group label="Facebook" label-for="input-23">
                <b-form-input id="input-23" type="url" v-model="user.facebook">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

import { sharedService } from "../../services";
import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;

SimpleVueValidation.extendTemplates({
  required: "Obrigatório",
  greaterThanOrEqualTo: "Infome/Escolha ao menos {0} opção.",
  length: "O tamanho mínimo é de {0} caracteres.",
  integer: "Infomre um valor inteiro (sem os centavos) - Somente o numero",
});

export default {
  data() {
    return {
      tipoSexo: [
        { id: "F", nome: "Feminino" },
        { id: "M", nome: "Masculino" },
      ],
      tipoCnh: [
        { id: "A", nome: "A" },
        { id: "B", nome: "B" },
        { id: "AB", nome: "AB" },
        { id: "C", nome: "C" },
        { id: "D", nome: "D" },
        { id: "E", nome: "E" },
      ],
      tipoCivil: [
        { id: "C", nome: "Casado(a)" },
        { id: "S", nome: "Solteiro(a)" },
        { id: "D", nome: "Separado(a)/divorciado(a)" },
        { id: "V", nome: "Viuvo(a)" },
        { id: "O", nome: "Outros" },
      ],
      tipoEscolaridade: [
        { id: "0", nome: "Ensino Básico - Até 5º Ano" },
        { id: "1", nome: "Primário - Até 9 Ano" },
        { id: "2", nome: "Segundo Grau" },
        { id: "3", nome: "Segundo Grau - Técnico" },
        { id: "4", nome: "Técnico - Superior" },
        { id: "5", nome: "Curso Superior" },
        { id: "6", nome: "Pós-Graduação" },
        { id: "7", nome: "Mestrado" },
        { id: "8", nome: "Doutorado" },
      ],
      tipoDeficiencia: [
        { id: "A", nome: "Auditiva" },
        { id: "B", nome: "Cognitiva" },
        { id: "C", nome: "Motora" },
        { id: "D", nome: "Visual" },
      ],
      cargosPretendidos: [],
      areaPretendida: [],
      is_edit: null,
      is_endereco_edit: null,
      fileInput: null,
      dateFormat: null,
    };
  },
  validators: {
    "user.nome": function (value) {
      return Validator.value(value).required();
    },

    "user.data_nascimento": function (value) {
      return Validator.value(value)
        .required()
        .length(10)
        .custom(function () {
          var date = value;
          var ardt = new Array();
          var ExpReg = new RegExp(
            "(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[12][0-9]{3}"
          );
          ardt = date.split("/");
          let erro = false;
          if (date.search(ExpReg) == -1) {
            erro = true;
          } else if (
            (ardt[1] == 4 || ardt[1] == 6 || ardt[1] == 9 || ardt[1] == 11) &&
            ardt[0] > 30
          )
            erro = true;
          else if (ardt[1] == 2) {
            if (ardt[0] > 28 && ardt[2] % 4 != 0) erro = true;
            if (ardt[0] > 29 && ardt[2] % 4 == 0) erro = true;
          }
          if (erro) return "Data Inválida";
          //Idade Minima 14 anos
          var parts = date.split("/");
          var dt_us = new Date(parts[2], parts[1] - 1, parts[0]).getFullYear();
          var d1 = new Date().getFullYear();
          var lapse = d1 - dt_us;
          if (lapse<14) return "Idade Minima para cadastro é de 14 anos completos";
        });
    },


    "user.email": function (value) {
      return Validator.value(value).required().email();
    }
    
  },

  computed: {
    user: function () {
      let _user = this.$store.getters.getUser;
      if (this.$store.getters.getGoogleObj.googleId && !_user.id > 0) {
        let _objGoogle = this.$store.getters.getGoogleObj;
        _user.token_google = _objGoogle.googleId;
        //_user.nome = _objGoogle.nome;
        _user.email = _objGoogle.email;
        _user.foto = _objGoogle.foto;
        //console.log(_objGoogle.nome);
        //console.log(_user.foto);
      }
      return _user;
    },
  },

  methods: {
    formatPicker(date) {
      let self = this;
      const [day, month, year] = date.split("/");

      console.log(`${year}-${month}-${day}`);

      self.dateFormat = `${year}-${month}-${day}`;
    },

    dateFormatter(date) {
      let self = this;

      if (!date.selectedYMD) return null;

      const [year, month, day] = date.selectedYMD.split("-");

      self.user.data_nascimento = `${day}/${month}/${year}`;
    },

    pickImage() {
      this.$refs.pickAvatar.$el.childNodes[0].click();
    },

    upload() {
      let self = this;
      sharedService
        // eslint-disable-next-line
        .sendFiles("Candidato/anexo", fileInput.files[0])
        .then(function (obj) {
          obj.text().then(function (text) {
            if (obj.status === 200) {
              let foto = JSON.parse(text);
              self.user.foto = foto;
            }
          });
        });
    },

    async buscarCargos(value) {
      let self = this;
      await sharedService
        .read(
          "cargo/" +
            this.$store.getters.getApiKey +
            '?filtros=[["nome","like","' +
            value +
            '%"]]&limit=15'
        )
        .then(function (obj) {
          self.cargosPretendidos = obj.obj;
        });
    },

    async buscarAreas(value) {
      this.value = value;
      let self = this;
      await sharedService
        .read(
          "cargo_area/" +
            this.$store.getters.getApiKey +
            '?filtros=[["nome","like","' +
            value +
            '%"]]&limit=15'
        )
        .then(function (obj) {
          self.areaPretendida = obj.obj;
        });
    },

    findcep: function () {
      let self = this;
      let val = this.user.cep.replace(/\D/g, "");
      if (val.length === 8) {
        fetch("https://viacep.com.br/ws/" + val + "/json/")
          .then(function (response) {
            return response.json();
          })
          .then(function (result) {
            console.log(result)
            if (result.erro) {
              self.user.logradouro = "";
              self.user.bairro = "";
              self.user.estado_id.id = "";
              self.user.estado_id.nome = "";
              self.user.cidade_id.id = "";
              self.user.cidade_id.nome = "";
              return;
            }
            self.user.logradouro = result.logradouro;
            self.user.bairro = result.bairro;
            let ibge = result.ibge;
            self.user.estado_id.id = ibge.substring(0, 2);
            self.user.estado_id.nome = result.uf;
            self.user.cidade_id.id = ibge;
            self.user.cidade_id.nome = result.localidade;
          });
      }
      if (val.length === 0) {
        self.user.logradouro = "";
        self.user.bairro = "";
        self.user.estado_id.id = "";
        self.user.estado_id.nome = "";
        self.user.cidade_id.id = "";
        self.user.cidade_id.nome = "";
        return;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.left-column-wrapper {
  border-left: 5px solid #c7c7c7;
  border-radius: 5px;
}

@media (max-width: 430px) {
  .left-column-wrapper {
    border-right: 0px solid;
  }
}

.message {
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
</style>
